import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowSplitDown1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowSplitDown1"><Path d="M3.5 14.5V20.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.5 20.5H20.5V14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12V3.5M12 12L4 20M12 12L20 20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowSplitDown1;
